import React, {useEffect, useRef, useState} from 'react';
import Lottie from 'lottie-react';
import {
  AnimatedBox,
  Box,
  Typography,
  useSpring,
  VisibilityBox,
  ArtistQuote,
} from '@ttx/design-system';
import quoteBlockAnimation from '../../public/lottie/quote-block.json';

interface QuoteBlockAnimationProps {
  playAnimation: boolean;
  quoteText: string;
  quoteArtist?: string;
}

export const QuoteBlockAnimation: React.FC<QuoteBlockAnimationProps> = ({
  playAnimation,
  quoteText,
  quoteArtist,
}: QuoteBlockAnimationProps) => {
  const lottieRef = useRef<any>(null);
  const lottieRefTwo = useRef<any>(null);

  const [startAnimation, setStartAnimation] = useState(false);
  const heightStyle = useSpring({
    config: {duration: 400},
    from: {maxHeight: '120px'},
    to: {
      maxHeight: startAnimation ? '1000px' : '120px',
    },
    delay: 100,
  });

  const textStyles = useSpring({
    config: {duration: 300},
    from: {transform: 'scale(0)'},
    to: {
      transform: startAnimation ? 'scale(1)' : 'scale(0)',
    },
    delay: 800,
  });

  useEffect(() => {
    if (playAnimation) {
      setStartAnimation(true);
      lottieRef.current?.playSegments([0, 121], true);
      lottieRefTwo.current?.playSegments([0, 121], true);
    }
  }, [playAnimation]);

  return (
    <Box>
      <VisibilityBox show={[true, false]}>
        <ArtistQuote artistName={quoteArtist} quote={quoteText} />
      </VisibilityBox>
      <VisibilityBox show={[false, true]}>
        <Box paddingY="twenty" paddingX="lg">
          <Box width="73.15%" css={{marginBottom: -60}}>
            <Lottie
              animationData={quoteBlockAnimation}
              lottieRef={lottieRef}
              loop={false}
              autoplay={false}
            />
          </Box>
          <Box>
            <AnimatedBox style={{position: 'absolute', ...textStyles}}>
              <Typography
                textAlign="center"
                textStyle="h1"
                style={{lineHeight: 1}}
                css={{
                  WebkitTextStroke: '1px white',
                  color: '#303030',
                }}
              >
                {`"${quoteText}" `} {quoteArtist ? `-${quoteArtist}` : null}
              </Typography>
            </AnimatedBox>
          </Box>
          <AnimatedBox style={heightStyle}>
            <Typography
              textAlign="center"
              textStyle="h1"
              style={{lineHeight: 1}}
              color="transparent"
            >
              {`"${quoteText}" `} {quoteArtist ? `-${quoteArtist}` : null}
            </Typography>
          </AnimatedBox>
          <Box
            width="73.15%"
            style={{transform: 'scale(-1)', marginLeft: 'auto'} as any}
            css={{marginTop: -60}}
          >
            <Lottie
              animationData={quoteBlockAnimation}
              lottieRef={lottieRefTwo}
              loop={false}
              autoplay={false}
            />
          </Box>
        </Box>
      </VisibilityBox>
    </Box>
  );
};
